const codeList = {
    820: 'ENOTIFY',
    ENOTIFY: 'ENOTIFY',
    A3: 'A3',
    A4: 'A4',
    A5: 'A5',
    A6: 'A6',
};
Object.freeze(codeList);
export default codeList;
